(() => {
    const $siteHeader = document.querySelector('.site-header');
    const $siteMenuModal = document.querySelector('.site-menu-modal');

    let lastScrollPos = window.scrollY;

    const initSiteHeader = () => {
        const $firstBlock = document.querySelector('.block');

        if (!$siteHeader) return;

        if ($firstBlock && ['background-color-black', 'background-color-navy', 'background-color-mauve'].some((className) => $firstBlock.classList.contains(className))) {
            $siteHeader.classList.add('site-header--white');
        }

        setTimeout(() => {
            $siteHeader.classList.add('site-header--initiated');
        }, 300);
    };

    const initSiteHeaderBackground = () => {
        if (!$siteHeader) return;

        if (window.scrollY === 0) {
            $siteHeader.classList.remove('site-header--scrolled');
        } else {
            $siteHeader.classList.add('site-header--scrolled');
        }
    };

    const toggleSiteHeader = () => {
        if (window.scrollY > lastScrollPos && window.scrollY > 100) {
            $siteHeader.classList.add('site-header--hide');

            lastScrollPos = window.scrollY;
        };
        
        if (window.scrollY <= 100 || window.scrollY < lastScrollPos - 100) {
            $siteHeader.classList.remove('site-header--hide');

            lastScrollPos = window.scrollY;
        };
    };

    if ($siteHeader && $siteMenuModal) {
        $siteMenuModal.addEventListener('modalopen', () => {
            $siteHeader.classList.add('site-header--site-menu-modal-open');
        });

        $siteMenuModal.addEventListener('modalclose', () => {
            $siteHeader.classList.remove('site-header--site-menu-modal-open');
        });
    }

    window.addEventListener('scroll', () => {
        toggleSiteHeader();
        initSiteHeaderBackground();
    });

    initSiteHeader();
    initSiteHeaderBackground();

    const $themeToggles = document.querySelectorAll('.theme-toggle');

    if ($themeToggles.length) {
        const themeKey = 'theme-mode';

        const getStoredTheme = () => {
            try {
                const stored = localStorage.getItem(themeKey);
                if (stored === 'calm' || stored === 'vibrant') return stored;
            } catch (e) {}

            const cookie = document.cookie.split('; ').find(part => part.startsWith(`${themeKey}=`));
            const value = cookie ? cookie.split('=')[1] : '';

            return value === 'calm' || value === 'vibrant' ? value : 'vibrant';
        };

        const setTheme = (calm) => {
            document.documentElement.classList.toggle('theme-calm', calm);
            document.body.classList.toggle('theme-calm', calm);

            $themeToggles.forEach($toggle => {
                $toggle.setAttribute('aria-pressed', calm ? 'true' : 'false');
            });

            try {
                localStorage.setItem(themeKey, calm ? 'calm' : 'vibrant');
            } catch (e) {}

            const secure = window.location.protocol === 'https:' ? '; Secure' : '';
            document.cookie = `${themeKey}=${calm ? 'calm' : 'vibrant'}; path=/; max-age=31536000; SameSite=Lax${secure}`;
        };

        setTheme(getStoredTheme() === 'calm');

        $themeToggles.forEach($toggle => {
            $toggle.addEventListener('click', () => {
                setTheme(!document.body.classList.contains('theme-calm'));
            });
        });
    }
})();
